import React from 'react'
import { createTheme, ThemeProvider, StyledEngineProvider } from '@mui/material/styles'

const theme = createTheme({
  typography: {
    fontSize: 16,
    button: {
      textTransform: 'none'
    }
  },
  shape: {
    borderRadius: 0
  },
  palette: {
    primary: {
      main: '#0056ac'
    },
    secondary: {
      main: '#26292e'
    }
  }
})

const Theme = ({ ...props }) => {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme} {...props} />
    </StyledEngineProvider>
  )
}

export default Theme
